
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $9DiKA = parcelRequire("9DiKA");

var $f3WAG = parcelRequire("f3WAG");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $5DwXE = parcelRequire("5DwXE");

var $bV0pP = parcelRequire("bV0pP");
const $a8c1dd334321f150$var$map = new (0, $5DwXE.default)({
    layers: [
        new (0, $4mWlF.default)({
            source: new (0, $9jDAx.default)()
        })
    ],
    target: "map2d",
    controls: (0, $f3WAG.defaults)({
        attributionOptions: {
            collapsible: false
        }
    }),
    view: new (0, $9DiKA.default)({
        center: [
            333333,
            1500000
        ],
        zoom: 6
    })
});
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $a8c1dd334321f150$var$ol3d = new (0, $cc3xD.default)({
    map: $a8c1dd334321f150$var$map /*, target: 'map3d'*/ 
});
const $a8c1dd334321f150$var$scene = $a8c1dd334321f150$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$a8c1dd334321f150$var$scene.terrainProvider = tp);
$a8c1dd334321f150$var$ol3d.setEnabled(true);
/**
 * @param {!olcs.OLCesium} ol3d
 * @constructor
 */ const $a8c1dd334321f150$var$OlcsControl = function(ol3d) {
    /**
   * @type {!olcs.OLCesium}
   * @private
   */ this.ol3d_ = ol3d;
};
/**
 * Almost PI / 2.
 * @const
 * @type {number}
 */ $a8c1dd334321f150$var$OlcsControl.MAX_TILT = 7 * Math.PI / 16;
/**
 * @const
 * @type {number}
 */ $a8c1dd334321f150$var$OlcsControl.MIN_TILT = 0;
/**
 * @return {ol.View}
 */ $a8c1dd334321f150$var$OlcsControl.prototype.getOlView = function() {
    return this.ol3d_.getOlView();
};
/**
 * @return {Array.<number>}
 */ $a8c1dd334321f150$var$OlcsControl.prototype.getTiltRange = function() {
    return [
        $a8c1dd334321f150$var$OlcsControl.MIN_TILT,
        $a8c1dd334321f150$var$OlcsControl.MAX_TILT
    ];
};
/**
 * @return {number}
 */ $a8c1dd334321f150$var$OlcsControl.prototype.getHeading = function() {
    return this.getOlView().getRotation() || 0;
};
/**
 * @return {number|undefined}
 */ $a8c1dd334321f150$var$OlcsControl.prototype.getTiltOnGlobe = function() {
    const scene = this.ol3d_.getCesiumScene();
    const tiltOnGlobe = (0, $cc3xD.computeSignedTiltAngleOnGlobe)(scene);
    return -tiltOnGlobe;
};
/**
 * @param {function()} callback
 */ $a8c1dd334321f150$var$OlcsControl.prototype.resetToNorthZenith = function(callback) {
    const scene = this.ol3d_.getCesiumScene();
    const camera = scene.camera;
    const pivot = (0, $cc3xD.pickBottomPoint)(scene);
    if (!pivot) {
        callback();
        return;
    }
    const currentHeading = this.getHeading();
    const angle = (0, $cc3xD.computeAngleToZenith)(scene, pivot);
    // Point to North
    (0, $cc3xD.setHeadingUsingBottomCenter)(scene, currentHeading, pivot);
    // Go to zenith
    const transform = Cesium.Matrix4.fromTranslation(pivot);
    const axis = camera.right;
    const options = {
        callback: callback
    };
    (0, $cc3xD.rotateAroundAxis)(camera, -angle, axis, transform, options);
};
$a8c1dd334321f150$var$OlcsControl.prototype.rotate = function(angle) {
    const view = this.ol3d_.getOlView();
    const current = view.getRotation();
    view.animate({
        rotation: current + angle,
        duration: 250
    });
};
/**
 * @param {number} angle
 */ $a8c1dd334321f150$var$OlcsControl.prototype.setHeading = function(angle) {
    const scene = this.ol3d_.getCesiumScene();
    const bottom = (0, $cc3xD.pickBottomPoint)(scene);
    if (bottom) (0, $cc3xD.setHeadingUsingBottomCenter)(scene, angle, bottom);
};
/**
 * @param {number} angle
 */ $a8c1dd334321f150$var$OlcsControl.prototype.tiltOnGlobe = function(angle) {
    const scene = this.ol3d_.getCesiumScene();
    const camera = scene.camera;
    const pivot = (0, $cc3xD.pickBottomPoint)(scene);
    if (!pivot) // Could not find the bottom point
    return;
    const options = {};
    const transform = Cesium.Matrix4.fromTranslation(pivot);
    const axis = camera.right;
    (0, $cc3xD.rotateAroundAxis)(camera, -angle, axis, transform, options);
};
window["control"] = new $a8c1dd334321f150$var$OlcsControl($a8c1dd334321f150$var$ol3d); // eslint-disable-line no-unused-vars


//# sourceMappingURL=rotate.2ffc2ca0.js.map
